<div class="row" style="margin-left: 0px;margin-right: 0px;">
    <div class="col-md-9 paralex" style="margin-top: -24px;margin-left: 0px;height: 758px;">

        <div class='stars'></div>
        <div class='stars2'></div>
        <div class='stars3'></div>
        <img src="assets/images/qmsLogo.png" alt="">

    </div>
    <div class="col-md-3 login-panel" *ngIf="logout" style="margin-top: -24px;height: 741px;margin-right: -1px;">
        <div class=" auth-content" (keyup.enter)="login()">
            <!-- <img src="assets/images/qubeslogo.JPG" alt="" class="img-fluid mb-4 d-block d-xl d-lg"> -->
            <!-- <img src="assets/images/QMS BIlling Logo FA v7-03_new.png" alt="" class="img-fluid mb-4 d-block d-xl d-lg"> -->
            <h3 class="mt-6 f-w-400">Sign In</h3>
            <div class="input-group mb-4">
                <div class="input-group-prepend">
                    <span class="input-group-text"><i class="feather icon-mail" ></i></span>
                </div>
                <input type="text" class="form-control" (focus)="singnref()" placeholder="Email address / User ID" [(ngModel)]="userName" (keydown.space)="$event.preventDefault()">
            </div>
            <p *ngIf="externalUserNotExistFlag" style="color: rgb(223, 75, 69); ">User Name is Not Found!</p>

            <div class="input-group mb-4">
                <div class="input-group-prepend">
                    <span class="input-group-text"><i class="feather icon-lock"></i></span>
                </div>
                <input type="text" class="form-control" placeholder="OTP" [(ngModel)]="password" style="width: 70%;margin-right: 5%;" maxlength="6">
                <button class="btn btn-success" style="width: 25%;font-size: 12px;" (click)="sendOtp()" [disabled]="(subscribeTimer != 0)">Send OTP <span
                        *ngIf="subscribeTimer != 0">({{subscribeTimer}})</span></button>
            </div>


            <p *ngIf="otpValidFlag" style="color: rgb(223, 75, 69); font-style:italic">Invalid Otp</p>

            <button class="btn btn-block btn-primary mb-0" (click)=login() [disabled]="password.length < 6 || loginUsingPasswordButton"> Sign
                In</button>
            <br>
            <button class="btn btn-block btn-danger mb-0" (click)=logouts()> LogOut From All Devices
                </button>
            <br>
            <!-- <div class="text-center or"><span>OR</span></div> -->
            <button *ngIf="loginUsingPasswordButton" class="btn btn-block btn-warning mb-0" (click)="loginUsingPassword()"> Login with Password</button>
            <div class="text-center">
            </div>
        </div>

    </div>
    <div class="col-md-3 login-panel" *ngIf="!logout">
        <div class=" auth-content" (keyup.enter)="login()">
            <!-- <img src="assets/images/qubeslogo.JPG" alt="" class="img-fluid mb-4 d-block d-xl d-lg"> -->
            <!-- <img src="assets/images/QMS BIlling Logo FA v7-03_new.png" alt="" class="img-fluid mb-4 d-block d-xl d-lg"> -->
            <h3 class="mt-6 f-w-400">Logout From All Devices</h3><br>
            <div class="input-group mb-4">
                <div class="input-group-prepend">
                    <span class="input-group-text"><i class="feather icon-mail" ></i></span>
                </div>
                <input type="text" class="form-control" placeholder="Enter Email Id / User ID" [(ngModel)]="userNamelogout" (keydown.space)="$event.preventDefault()">
            </div>
            <p *ngIf="externalUserNotExistFlag" style="color: rgb(223, 75, 69); ">User Name is Not Found!</p>

            <!-- <div class="input-group mb-4"> -->
            <!-- <div class="input-group-prepend">
                    <span class="input-group-text"><i class="feather icon-lock"></i></span>
                </div> -->
            <!-- <input type="text" class="form-control" placeholder="Enter OTP" [(ngModel)]="passwordlogout" style="width: 70%;margin-right: 5%;" maxlength="6">
                <button class="btn btn-success" style="width: 25%;font-size: 12px;" (click)="sendOtplogout()" (focus)="logfreshsingn()" [disabled]="(subscribeTimersLogout != 0)">Send OTP <span
                        *ngIf="subscribeTimersLogout != 0">({{subscribeTimersLogout}})</span></button> -->
            <!-- </div> -->


            <!-- <p *ngIf="otpValidFlag" style="color: rgb(223, 75, 69); font-style:italic">Invalid Otp</p> -->


            <button class="btn btn-block btn-danger mb-0" (click)="sendOtpins()"> LogOut From All Devices
                </button>
            <br>
            <button class="btn btn-block btn-primary mb-0" (click)="logins()" (focus)="datas()"> Back
            </button>
            <br>
            <div class="text-center">
            </div>
        </div>
    </div>
</div>